import Button from 'components/common/Button';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Itinerary } from 'services/dataService';
import styled from 'styled-components';
import { colors, containerStyles } from 'styles/shared';
import PlanItem from './components/PlanItem';

const PlansContainer = styled.div`
  width: 54.4rem;
  height: 81.8rem;
  margin-bottom: 5rem;
  margin-right: 5rem;
  padding: 3.9rem 4.9rem 4.9rem;
  ${containerStyles};

  > div {
    margin-bottom: 3.5rem;
  }
`;

const ButtonOverride = styled(Button)`
  border: 0.2rem solid ${colors.blue_main};
`;

SelectedPlansOptionsSection.propTypes = {
  itineraries: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeItinerary: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};


function SelectedPlansOptionsSection({ itineraries, activeItinerary, onSelect, onDelete }) {
  const [displayItineraries, setDisplayItineraries] = useState([] as Itinerary[]);
  
  useEffect(() => {
    let display: any = [];

    for (let index = 0; index < itineraries.length && index < 10; index++) {
      display.push(itineraries[index]);
    }
    
    setDisplayItineraries(display);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itineraries]);

  function render() {
    return (
      <PlansContainer>
        {displayItineraries.map((itinerary: any) => {
          return <PlanItem key={itinerary.id} plan={itinerary} activePlan={activeItinerary ? activeItinerary : {} as Itinerary} onSelect={onSelect}/>;
        })}
        <ButtonOverride isActive={activeItinerary.id !== undefined} onClick={() => onDelete(activeItinerary.id)}>
          Delete selected trip
        </ButtonOverride>
      </PlansContainer>
    );
  }

  return render();
}

export default SelectedPlansOptionsSection;
